import * as Yup from "yup";

export const articleValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن موبایل الزامی است"),
    shortDescription: Yup.string()
    .required("وارد کردن توضیحات کوتاه الزامی است"),
    seoDescription: Yup.string()
    .required("وارد کردن توضیحات سئو الزامی است")
});
